import { render } from "./ProjectActivityReport.vue?vue&type=template&id=e0465754&scoped=true"
import script from "./ProjectActivityReport.vue?vue&type=script&lang=js"
export * from "./ProjectActivityReport.vue?vue&type=script&lang=js"

import "./time-reports.scss?vue&type=style&index=0&id=e0465754&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0465754"]])

export default __exports__